import React from "react";

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";

import { ProformaItem } from "./ProformaItem";
import { useSelector } from "react-redux";

export const MesaEntradaAccordionProformas = (props) => {
  const { onForm } = props;
  const { proformas } = useSelector(state => state.mesaEntrada);

  return (
    <>
      {proformas?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ width: "7%" }}>Estado</TableCell>
              <TableCell align="center" style={{ width: "10%" }}>Id Comprobante</TableCell>
              <TableCell align="center" style={{ width: "15%" }}>N° Comprobante</TableCell>
              <TableCell align="center" style={{ width: "15%" }}>Tramite</TableCell>
              <TableCell align="center" style={{ width: "15%" }}>Destino</TableCell>
              <TableCell align="center" style={{ width: "15%" }}>Fecha Comprobante</TableCell>
              <TableCell align="center" style={{ width: "15%" }}>Fecha Vencimiento</TableCell>
              <TableCell align="center" style={{ width: "15%" }}>Total Comprobante</TableCell>
              <TableCell align="center" style={{ width: "20%" }}></TableCell>
              {onForm && (
                <TableCell align="center" style={{ width: "20%" }}></TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {proformas.map((proforma, index) => {
                return (
                  <ProformaItem
                    key={index}
                    item={proforma}
                    onForm={onForm}
                    {...props}
                  />
                );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontSize: "1.1rem", fontStyle: "italic" }}>
          No hay Proformas
        </Typography>
      )}
    </>
  );
};
